import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar/Navbar";
import Sidebar from "../components/Sidebar/Sidebar";
import { useUsuario } from "../context/usuarioContext";
import socketIOClient , {Socket,io} from "socket.io-client"
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);
  const [selectedItem, setSelectedItem] = useState('');
  const [selectedItemNoExpanded, setSelectedItemNoExpanded] = useState('')
  const [subSelectedItem, setSubSelectedItem] = useState('')
  const [navSelectedItem, setNavSelectedItem] = useState('');
  const [expandedItems, setExpandedItems] = useState({
    boleta: false,
    plan: false,
    solicitud: false,
  });
  const { usuario, contratos } = useUsuario();
  
  
  const [contratoSeleccionado, setContratoSeleccionado] = useState()

  useEffect(() => {
    if(contratos)
      setContratoSeleccionado(contratos[0])
  }, [contratos])

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setShowMenu(false);
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const [update,setUpdate]=useState(false);
  useEffect(() => {
      if(usuario){
        var endpoint ="https://socket2.tumundo.cl";
        const socket = socketIOClient(endpoint);
        let auxHas = usuario.Correo;
  
        socket.on("connect", () => {
          socket.emit("mundoSocial", {
            hashID: auxHas,
            mensaje: "front sv",
          });
        });
  
        socket.on("stats", (mensaje) => {

          if(mensaje && mensaje.tipo){
            navigate("/");
            Swal.fire({
              icon: mensaje.tipo,
              title: mensaje.mensaje,
              confirmButtonText: "Volver",
              focusConfirm: false,
              iconColor: mensaje.tipo ? "green" : "red",
              width: "40rem",
              customClass: {
                popup: "containerSwal",
                title: "titleSwal",
                closeButton: "...",
                icon: "iconSwal",
                confirmButton: "buttonSwal",
                denyButton: "...",
                cancelButton: "...",
              },
            });
          }
 
        });
    
        socket.on("disconnect", (reason) => {
          setUpdate(false);
        });
    
        socket.on("reconnect", function () {
          setUpdate(false);
          setUpdate(true);
          socket.emit("mundoSocial", {
            hashID: auxHas,
            mensaje: "front sv",
          });
        });

        return () => socket.disconnect();
      }
     
  
     
    }, [usuario]);

  return (
    <>    
      <div className="page">
        <header className="page__header">
          <div className="navbar">
            <Navbar
              navSelectedItem={navSelectedItem}
              setNavSelectedItem={setNavSelectedItem}
              setSelectedItem={setSelectedItem}
              setSelectedItemNoExpanded={setSelectedItemNoExpanded}
              setSubSelectedItem={setSubSelectedItem}
              expandedItems={expandedItems}
              setExpandedItems={setExpandedItems}
              contratos={contratos}
              setShowMenu={setShowMenu}
            />
          </div>
        </header>
        <aside className={`sidebar ${showMenu ? 'sidebar--mobile' : ''}`}>
          <Sidebar 
            showMenu={showMenu} 
            setShowMenu={setShowMenu}
            selectedItem={selectedItem}
            setSelectedItem={setSelectedItem}
            selectedItemNoExpanded={selectedItemNoExpanded}
            setSelectedItemNoExpanded={setSelectedItemNoExpanded}
            subSelectedItem={subSelectedItem}
            setSubSelectedItem={setSubSelectedItem}
            navSelectedItem={navSelectedItem}
            setNavSelectedItem={setNavSelectedItem}
            expandedItems={expandedItems}
            setExpandedItems={setExpandedItems}
            contratos={contratos}
            contratoSeleccionado={contratoSeleccionado}
            setContratoSeleccionado={setContratoSeleccionado}
          />
        </aside>
      </div>
      {
        !showMenu ? (
        <main className="page__main">
          <section className="page__main-content">
            {children}
          </section>
        </main>
        ) : null
      }
    </>
  );
};

export default Layout;